import { environment } from '../environments/environment';

import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


// routes/views
import { HomeComponent } from './home/home.component';
import { BuildComponent } from './build/build.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { NavComponent } from './nav/nav.component';
import { DeployComponent } from './deploy/deploy.component';  

// services 
import { GithubService } from './services/github.service';
import { DesignService } from './services/designs.service';
import { SafePipe } from './pipes/safe-pipe.pipe';
import { UserdataService } from './services/userdata.service';
import { AuthService } from './services/auth.service';
import { WindowRefService } from './services/window.service';
import { StripeService } from './services/stripe.service'

// pipes
import { FilterPipe} from './filter.pipe';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

// bootstrap
import { AlertModule } from 'ngx-bootstrap/alert';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { BsDropdownModule } from 'ngx-bootstrap';
import { TooltipModule } from 'ngx-bootstrap';
import { ButtonsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap';


// Firebase stuff
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { MyaccountComponent } from './myaccount/myaccount.component';
import { LoaderComponent } from './loader/loader.component';

const appRoutes: Routes = [
  { path: '', component: HomeComponent},
  { path: 'build', component: BuildComponent },
  { path: 'thankyou', component: ThankyouComponent},
  { path: 'deploy', component: DeployComponent},
  { path: 'myaccount', component: MyaccountComponent},
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BuildComponent,
    SafePipe,
    FilterPipe,
    ThankyouComponent,
    NavComponent,
    DeployComponent,
    MyaccountComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes, { useHash: false, enableTracing: false}),
    AlertModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase, 'angular-auth-firebase'),
    AngularFireDatabaseModule,
    AngularFireAuthModule
    // BrowserAnimationsModule
  ],
  providers: [
    GithubService,
    UserdataService,
    NavComponent,
    DesignService,
    AuthService,
    WindowRefService,
    StripeService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts